import { AxiosError } from 'axios';
import http, { Http } from '@/lib/http';
import { CreditCardBrand } from '@/types';

export type Installment = {
  id: string;
  amountInCents: number;
  dueDate: string;
  status: string;
  currency: string;
};

export type OffSchedulePaymentOptions = {
  brand: CreditCardBrand | null;
  cardNumber: string | null;
  totalAmountInCents: number;
  currency: string;
  minimumAmountInCents: number;
  email: string | null;
  nextDueInstallment: Installment;
  installmentPaymentMessage: string;
  payoffMessage: string;
};

type Args = {
  orderId: string;
  projectId: string;
};

function ctor(http: Http) {
  return async ({ orderId, projectId }: Args): Promise<OffSchedulePaymentOptions> => {
    try {
      const { data } = await http.get<OffSchedulePaymentOptions>(
        `/projects/${projectId}/loans/${orderId}/off-schedule-payment`,
      );
      return data;
    } catch (err) {
      throw (err as AxiosError).response?.data;
    }
  };
}

export const getOffSchedulePaymentOptions = ctor(http);
